<template>
  <div>
    <h1 style="margin-bottom: 20px;">
      <span style="margin-right: 20px;">审批类型：</span>
      <el-radio-group v-model="flowType" @input="handleFlowTypeChange">
        <el-radio :label="1">会审</el-radio>
        <el-radio :label="2">顺序审</el-radio>
      </el-radio-group>
    </h1>
    <!-- 审批层级最多 6 层；多个层级每层只能选择一个;添加审批人按钮(多个层级只能选择一个人；一个层级可以选择20个) -->
    <el-timeline>
      <el-timeline-item 
        v-for="(item, i) of menbers"
        :timestamp="flowType == 1 ? '会审' : '顺序' + (i + 1)"
        placement="top"
        :key="i"
      >
        <el-card class="card-sty">
          <el-button
            v-show="(flowType == 1 && item.menber.length < 6) || (flowType == 2 && item.menber.length == 0)"
            @click="chooseMenber({ index: i, isManager: false,flowType })"
            >添加审批人</el-button
          >
          <div class="men-box">
            <p
              v-for="user of item.menber"
              :key="user.emplId"
              class="men-item"
            >
              <img
                src="/images/web/p-default.png"
                width="50px"
                height="50px"
                alt=""
              />
              <span>{{ user.name }}</span>
              <span
                class="item-close close_icon"
                @click="delUser(i, user)"
              ></span>
            </p>
          </div>
          <p
            class="close-icon close_icon"
            v-show="menbers.length > 1"
            @click="$emit('delLeven', i)"
          ></p>
        </el-card>
      </el-timeline-item>
    </el-timeline>
    <el-button v-show="flowType == 2" @click="addLeven">添加审批层级</el-button>
  </div>
</template>
<script>
// API
import { dingtalkApi } from "@/assets/js/http-serve/dingtalkApi";

export default {
  props: {
    menbers: {
      type: Array,
      default: [{ appleven: 1, menber: [] }]
    }
  },
  data () {
    // 这里存放数据
    return {
      flowType: 2, 
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 选择类型
    handleFlowTypeChange(val){
      this.$emit('handleFlowTypeChange',val)
    },
    // 删除
    delUser (leven, user) {
      this.$emit("delUser", leven, user);
    },
    /** 添加审批人
     * @param index  层级标识
     * @param isManager 是否是添加部门主管 
     */
    chooseMenber ({ index, isManager,flowType }) {
      this.$emit("chooseMenber", { index, isManager,flowType });
    },
    // 添加审批层级
    addLeven () {
      const { menbers } = this;
      if (menbers.length === 1 && menbers[0].menber.length > 1) return this.$message.error('多个审批人不能添加审批层级')
      if (menbers.length >= 6) return this.$message.error('审批层级最多添加 6 层')
      this.$emit("addLeven");
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () { },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () { }
};
</script>
<style lang="less" scoped>
.card-sty {
  position: relative;
  .men-box {
    display: flex;
    overflow-x: auto;
    .men-item {
      margin: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
    }
    .item-close {
      display: inline-block;
      width: 20px;
      height: 20px;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .close-icon {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 5px;
    right: 10px;
  }
}
.close_icon {
  cursor: pointer;
  background-image: url("/images/icon/icon_close.png");
  background-size: 100% 100%;
  &:hover {
    background-image: url("/images/icon/icon_colse_hover.png");
  }
}
</style>



// WEBPACK FOOTER //
// pages/initiation/components/dingTalkuse/selfSelection.vue